
























































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { axiosM, axiosC, resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import SimplePaginationCmp from "@/components/simple_pagination.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import AddCRFdialog from "./addCRFdialog.vue";
@Component({
  components: {
    Copy,
    SimplePaginationCmp,
    ConfirmDialog,
    AddCRFdialog
  }
})
export default class ProjectCreateThirdListCmp extends Vue {
  @Prop()
  private groupId: any;
  @Prop()
  private cFangshi: any;
  private mobans: any[] = [];
  private filter: any = {};
  private targetFangshi: any = "";
  private allFangshis: any[] = [];
  // 翻页
  private currentPage: any = 1;
  private totalCount: any = 0;
  private totalPage: any = 1;
  // 确认弹窗
  private cMoban: any = {};
  private confirmState: "delete" = "delete";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any = "您确定删除该设备数据么？";
  // 增加crf表弹出
  private ifShowAddCrf: boolean = false;

  /**
   * @description 获取已有的模板数据
   */
  private fetch() {
    const params: any = {
      params: {
        interview_id: this.cFangshi.interview_id,
        current_page: this.currentPage,
        page_count: 6
      }
    };
    axios.get("api/project/templates", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.mobans = data.data.templates;
        this.totalCount = data.data.total_count;
        this.totalPage = data.data.total_page;
      });
    });
  }
  /**
   * @description 重置页面
   */
  private refresh() {
    this.currentPage = 1;
    this.fetch();
  }
  // /**
  //  * @description 获得该项目的所有访视
  //  */
  // private fetchAllFangshis() {
  //   if (!this.groupId) {
  //     return;
  //   }
  //   const params: any = {
  //     params: {
  //       project_id: this.cFangshi.project_id,
  //       interview_id: this.cFangshi.interview_id
  //     }
  //   };
  //   axios.get("api/project/interview/plan", params).then(({ data }) => {
  //     resHandle(this, data).then(() => {
  //       this.allFangshis = data.data;
  //     });
  //   });
  // }
  /**
   * @description 复用已有方案
   */
  private targetFangshiChange(val) {
    this.targetFangshi = val;
    const params: any = {
      src_interview_id: val.interview_id,
      interview_id: this.cFangshi.interview_id
    };
    axios.post("api/project/interview/plan", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.fetch();
      });
    });
  }
  /**
   * @description 前一页
   */
  private prev() {
    if (this.currentPage === 1) {
      return;
    } else {
      this.currentPage--;
    }
    this.fetch();
  }
  /**
   * @description 后一页
   */
  private next() {
    if (this.currentPage >= this.totalPage) {
      return;
    } else {
      this.currentPage++;
    }
    this.fetch();
  }
  /**
   * @description 给当前访视添加一个模板
   */
  private addMoban() {
    this.ifShowAddCrf = true;
  }
  /**
   * @description 创建一个新的Crf
   */
  private addNewCrf() {
    this.$emit("cStateChange", "custom");
  }
  /**
   * @description 自定义模板编辑
   */
  private goToCustomMoban(moban) {
    this.$emit("compose", moban);
  }
  /**
   * @description 开始重命名模板
   */
  private startRenameMoban(moban) {
    moban.editing = true;
    this.$forceUpdate();
    this.$nextTick().then(() => {
      (this.$refs[moban.template_id][0] as any).focus();
    });
  }
  /**
   * @description 重命名模板
   */
  private renameMoban(moban) {
    if (!moban["名称"]) {
      this.$message.warning("必须填写一个名称");
      return;
    }
    const params: any = {
      template_id: moban.template_id,
      名称: moban["名称"]
    };
    axios.post("api/project/template/do", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        moban.editing = false;
        this.$message.success("重命名成功");
        this.$forceUpdate();
      });
    });
  }
  /**
   * @description 打开删除模板弹窗
   */
  private openDeleteDialog(moban) {
    this.cMoban = moban;
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "您确定删除该设备数据么？";
    this.confirmVisible = true;
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.confirmVisible = false;
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "delete":
        this.deleteThisMoban();
        break;
    }
  }
  /**
   * @description 删除一个模板
   */
  private deleteThisMoban() {
    const params: any = {
      data: {
        template_id: this.cMoban.template_id
      }
    };
    axios.delete("api/project/template", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetch();
    // this.fetchAllFangshis();
  }
}
